import { render, staticRenderFns } from "./task-model-view-wander.vue?vue&type=template&id=7010cc17&scoped=true&"
import script from "./task-model-view-wander.vue?vue&type=script&lang=ts&"
export * from "./task-model-view-wander.vue?vue&type=script&lang=ts&"
import style0 from "./task-model-view-wander.vue?vue&type=style&index=0&id=7010cc17&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7010cc17",
  null
  
)

export default component.exports